import {ChangeDetectorRef,Component,ElementRef,EventEmitter,Inject,Injectable,Input,LOCALE_ID,OnChanges,Output,SimpleChanges,} from '@angular/core';
import {CalendarDateFormatter,CalendarUtils,CalendarWeekViewComponent,DateAdapter,getWeekViewPeriod,} from 'angular-calendar';
import { WeekView,GetWeekViewArgs,WeekViewTimeEvent,EventColor,CalendarEvent,WeekViewAllDayEventRow,WeekViewAllDayEvent,} from 'calendar-utils';
import { DragEndEvent, DragMoveEvent } from 'angular-draggable-droppable';
import { CustomDateFormatter } from '../providers/custom-date-formatter.provider';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import _moment from 'proxies/dayjs';

export interface User {
  id: string;
  name: string;
  color: EventColor;
}

interface DayViewScheduler extends WeekView {
  users: User[];
}

interface GetWeekViewArgsWithUsers extends GetWeekViewArgs {
  users: User[];
}

@Injectable()
export class DayViewSchedulerCalendarUtils extends CalendarUtils {
  getWeekView(args: GetWeekViewArgsWithUsers): DayViewScheduler {
    const { period } = super.getWeekView(args);
    const view: DayViewScheduler = {
      period,
      allDayEventRows: [],
      hourColumns: [],
      users: [...args.users],
    };

    view.users.forEach((user, columnIndex) => {
      const events = args.events.filter(
        (event) => event.meta.user?event.meta.user.id === user.id:''
      );
      const columnView = super.getWeekView({
        ...args,
        events,
      });
      view.hourColumns.push(columnView.hourColumns[0]);
      columnView.allDayEventRows.forEach(({ row }, rowIndex) => {
        view.allDayEventRows[rowIndex] = view.allDayEventRows[rowIndex] || {
          row: [],
        };
        view.allDayEventRows[rowIndex].row.push({
          ...row[0],
          offset: columnIndex,
          span: 1,
        });
      });
    });

    return view;
  }
}

@Component({
    // tslint:disable-line max-classes-per-file
    selector: 'mwl-day-view-scheduler',
    templateUrl: 'day-view-schedular.component.html',
    providers: [
        DayViewSchedulerCalendarUtils,
        {
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter,
        }
    ],
    standalone: false
})
export class DayViewSchedulerComponent extends CalendarWeekViewComponent
  implements OnChanges {
  @Input() users: User[] = [];
  availableOt: any;
  @Output() userChanged = new EventEmitter();
  @Output() eventClicked = new EventEmitter<any>();
  view: DayViewScheduler;
  daysInWeek = 1;
  hasdata: User;
  valid: any;
  count = 0;
  tooltipText:any;
  tooltipTimeout: any;
  lastTooltipEvent: any;
  tooltipAppendToBody :boolean = false;

  constructor(
    protected cdr: ChangeDetectorRef,
    protected utils: DayViewSchedulerCalendarUtils,
    @Inject(LOCALE_ID) locale: string,
    private baseService: BaseService,
    protected dateAdapter: DateAdapter,
    protected element: ElementRef<HTMLElement>
  ) {
    super(cdr, utils, locale, dateAdapter, element);
    // super(cdr, utils, locale, dateAdapter, element);
  }

  getSlot(id: any){
    let ot_id = id;
    const d = new Date();
    let date =  _moment(d).subtract(0, 'days').startOf('day').valueOf();
    let day =  _moment(d).format('dd').toUpperCase();
    var hasArgs = {
      args: "roomtype_id:ot,ot_id:"+ ot_id +",slot_date:" + date + ",slot_days:" + day,
    }
    this.baseService.getData(hasArgs, "", "ot_slot", "ot", "OT_SLOT_LIST").subscribe((res) => {
      if (res.errCode == 0) {
        if (res.resource.length != 0) {
          this.availableOt = res.resource.map(x => {
            return {
              ot_id: ot_id,
              slot_start_time: x.slot_start_time,
            }
          });
        }
      }
    });
  }
  
  getAvail(event: any, hour: any) {
    for (let i = 0; i < this.users.length; i++) {
      if (i == event) {
        this.hasdata = this.users[i];
      }
    }
    if(this.valid != event && this.count < 5){
      console.log("checkk",event,"",this.count++)
      this.getSlot(this.hasdata.id)
    }
    this.valid = event;
    let start_time: any = new Date(hour.segments[0].date).toISOString();
    start_time =_moment(start_time).format('x');
    if(this.availableOt && this.hasdata.id == this.availableOt[0].ot_id && (this.availableOt[0].slot_start_time == start_time || (this.availableOt[0].slot_start_time < start_time && this.availableOt[this.availableOt.length - 1].slot_start_time > start_time))){
      return true;
    }
    else{
      return false;
    }
  }

  trackByUserId = (index: number, row: User) => row.id;

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.users) {
      this.refreshBody();
      this.emitBeforeViewRender();
      if (this.events.length > 0 && this.events.some(event => event.meta?.user?.showTooltip === true)) {
          this.tooltipAppendToBody = false;
      }
    }
  }

  getDayColumnWidth(eventRowContainer: HTMLElement): number {
    return Math.floor(eventRowContainer.offsetWidth / this.users.length);
  }

  dragMove(dayEvent: WeekViewTimeEvent, dragEvent: DragMoveEvent) {
    if (this.snapDraggedEvents) {
      const newUser = this.getDraggedUserColumn(dayEvent, dragEvent.x);
      const newEventTimes = this.getDragMovedEventTimes(
        dayEvent,
        { ...dragEvent, x: 0 },
        this.dayColumnWidth,
        true
      );
      const originalEvent = dayEvent.event;
      const adjustedEvent = {
        ...originalEvent,
        ...newEventTimes,
        meta: { ...originalEvent.meta, user: newUser },
      };
      const tempEvents = this.events.map((event) => {
        if (event === originalEvent) {
          return adjustedEvent;
        }
        return event;
      });
      this.restoreOriginalEvents(
        tempEvents,
        new Map([[adjustedEvent, originalEvent]])
      );
    }
    this.dragAlreadyMoved = true;
  }

  dragEnded(
    weekEvent: WeekViewAllDayEvent | WeekViewTimeEvent,
    dragEndEvent: DragEndEvent,
    dayWidth: number,
    useY = false
  ) {
    super.dragEnded(
      weekEvent,
      {
        ...dragEndEvent,
        x: 0,
      },
      dayWidth,
      useY
    );
    const newUser = this.getDraggedUserColumn(weekEvent, dragEndEvent.x);
    if (newUser && newUser !== weekEvent.event.meta.user) {
      this.userChanged.emit({ event: weekEvent.event, newUser });
    }
  }

  protected getWeekView(events: CalendarEvent[]) {
    return this.utils.getWeekView({
      events,
      users: this.users,
      viewDate: this.viewDate,
      weekStartsOn: this.weekStartsOn,
      excluded: this.excludeDays,
      precision: this.precision,
      absolutePositionedEvents: true,
      hourSegments: this.hourSegments,
      dayStart: {
        hour: this.dayStartHour,
        minute: this.dayStartMinute,
      },
      dayEnd: {
        hour: this.dayEndHour,
        minute: this.dayEndMinute,
      },
      segmentHeight: this.hourSegmentHeight,
      weekendDays: this.weekendDays,
      ...getWeekViewPeriod(
        this.dateAdapter,
        this.viewDate,
        this.weekStartsOn,
        this.excludeDays,
        this.daysInWeek
      ),
    });
  }

  private getDraggedUserColumn(
    dayEvent: WeekViewTimeEvent | WeekViewAllDayEvent,
    xPixels: number
  ) {
    const columnsMoved = Math.round(xPixels / this.dayColumnWidth);
    const currentColumnIndex = this.view.users.findIndex(
      (user) => user === dayEvent.event.meta.user
    );
    const newIndex = currentColumnIndex + columnsMoved;
    return this.view.users[newIndex];
  }

  getCustomToolTip(event?: any): string {
    if(event?.event?.total_booked == 0 && event?.event?.over_booking_count){
        return
    }
    const eventChanged = this.getTooltipOver(event, ['slot_start_time', 'slot_end_time', 'machine_id']);
    if (eventChanged && event.custom_tooltip_dataSource) {
      this.tooltipText = null;
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
      this.tooltipTimeout = setTimeout(() => {
        this.lastTooltipEvent = event;
        const dataSource = { ...event.custom_tooltip_dataSource };
        dataSource.args = this.baseService.buildDyanamicStr(event.custom_tooltip_dataSource.args, { data: event });
        this.baseService.getByDataSource(dataSource).subscribe(res => {
          if (res.errCode == 0 && res.resource?.length > 0) {
            this.tooltipText = res.resource.map((row: any, i: number) => { const r:any={}; for (const k in row) r[k.toLowerCase()]=row[k]; return `${i+1}. ` + Object.entries(event.custom_tootip_key_to_show as Record<string,string>).map(([l,k]) => r[k.toLowerCase()]!=null && r[k.toLowerCase()]!=='' ? `${l}: ${r[k.toLowerCase()]}` : null).filter(Boolean).join(' , ') }).filter(Boolean).join('\n');
          } else {
            this.tooltipText = ' ';
          }
          this.cdr.detectChanges();
        });
      }, 100);
    }
    return this.tooltipText;
  }


  
  getTooltipOver(event?, fields?) { // only use for repeat hover event or prevent multiple calling
    if (!this.lastTooltipEvent) return true;
    return fields.some(field =>
      this.lastTooltipEvent?.[field] !== event?.[field]
    );
  }


  handleEvent(eventData: any, allDayEvent: any) {
    const event = allDayEvent?.event;
    if (event?.event.status == 'booked') {
      return; 
    }
    //  allow click
    this.eventClicked.emit({
      event: event,
      sourceEvent: eventData?.sourceEvent
    });
  }

  
}
